<script>
import YandexSmartCapthca from "@/modules/core/components/YandexSmartCapthca.vue";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import names from "@/modules/survey/routers/names";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AttemtByEmail",
  components: {YandexSmartCapthca},
  mixins:[
    FormErrorsMixin
  ],
  props: {
    surveyData: {
      type: Object,
      required: true
    },
    attemptStatus: {
      type: Boolean,
      required: false
    }
  },
  data(){
    return {
      email: undefined,
      loading: false,
      rules: {
        required: value => !!value || 'Необходимо указать почту',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/
          return pattern.test(value) || 'Некоректный формат email.'
        },
      }
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticate: 'auth/isAuthenticated'
    }),
  },
  methods: {
    ...mapActions({
      LoadSurveyDetail: 'surveying/LoadSurveyDetail',
      checkAttempt: "surveying/CheckAttempt",
      createAttempt: "surveying/createAttempt",
    }),
    checkView(token=null) {
      this.loading = true;
      this.checkAttempt({
        survey_id: this.surveyData.id,
        email: this.email !== undefined && this.email !== '' ? this.email: undefined,
        key: this.$route.query.key,
        token: token,
        finalizer: (val) => {
          this.$emit('continue', val)
          this.loading = false;
        },
        catcher:(val, url, status) => {
          if (status === 500)
            val = {'non_field_errors': ['Ошибка в работе сервиса!']}
          this.loading = false;
          this.errors.non = [];
          this.mapErrors(val);
          this.$refs.captcha.reInit()
        }
      })
    },
  },
  created() {
    if (this.$route.query.email)
      this.email = this.$route.query.email
    if (this.isAuthenticate) {
      this.checkView()
    }
  },
}
</script>

<template>
  <v-sheet>
    <v-snackbar :value="hasError('user')" color="error" multi-line >
      {{getError('user')}}
    </v-snackbar>
    <v-snackbar :value="!!error" color="error" multi-line v-for="(error, index) in getNonFieldErrors()" :key="`error_${index}`">
      {{error[0]}}
      <template v-slot:action>
        <v-btn icon @click="deleteNonFieldError(error)"><v-icon>close</v-icon></v-btn>
      </template>
    </v-snackbar>
    <YandexSmartCapthca
      ref="captcha"
      container-id="not-auth-validate"
      v-if="!isAuthenticate && attemptStatus === undefined"
      invisible
      @approve="checkView"
      @fail="() => loading = false"
      class="mb-2"
      :errors="getError('captcha')"
    >
      <template v-slot:after="{ execute, isInit, isEnable }">
        <v-btn-toggle
          style="min-width: 300px"
        >
          <v-text-field
            ref="emailField"
            v-if="surveyData.anonymity === 1"
            v-model="email"
            outlined clearable dense
            label="Введите почту"
            :loading="loading"
            :readonly="isEnable && !isInit"
            :rules="[rules.required, rules.email]"
          ></v-text-field>
          <v-btn
            text height="40px"
            :readonly="isEnable && !isInit"
            @click="() => {
            if ($refs.emailField.validate(true)){
              loading = true
              execute()
            }
          }"
            :loading="loading"
          >
            Продолжить
          </v-btn>
        </v-btn-toggle>
      </template>
    </YandexSmartCapthca>
    <v-btn v-else-if="isAuthenticate && attemptStatus === undefined" :loading="loading" min-width="200"></v-btn>
  </v-sheet>

</template>

<style scoped>

</style>
